<ng-container class="report-custom-container">
    <app-report-select [title]="'Reporte combinado de Cambios de Medicación y RE/PRM'"
        (previewClicked)="handlePreviewClick()" (printClicked)="handlePrintClick()" (pdfClicked)="handlePdfClick()"
        (excelClicked)="handleExcelClick()">
        <div slot="content" class="container-options">
            <form [formGroup]="form">
                <section class="filter-container" *ngIf="typeGlobal" >
                    <div class="subtitle">Institución</div>
                    <app-form-field
                      class="field"
                      [type]="'select'"
                      label="Seleccione la institución"
                      [fieldControl]="form.controls['selectedInstitution'] | asFormControl"
                      [options]="selectOptionsInsitutions">
                    </app-form-field>
                </section>

                <section class="interval">
                    <p class="subtitle">Intervalo</p>

                    <div class="interval-days">
                        <mat-form-field>
                            <div class="label">Desde</div>
                            <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" />
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker">
                                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <div class="label">Selecciona una opción</div>
                            <mat-select formControlName="selectedOptionFrom">
                                <mat-option *ngFor="let option of schedulesOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="interval-days">
                        <mat-form-field>
                            <div class="label">Hasta</div>
                            <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" />
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker">
                                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
                            </mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>

                        <mat-form-field>
                            <div class="label">Selecciona una opción</div>
                            <mat-select formControlName="selectedOptionUntil">
                                <mat-option *ngFor="let option of schedulesOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </section>

                <section class="filter-container">
                    <p class="subtitle">Filtrar por</p>
                    <mat-checkbox [checked]="showPatientSelect" (change)="toggleSelectPatient()" [disabled]="!institutionSelected" class="col-12">
                        Paciente
                    </mat-checkbox>
                    <div class="select col-12" *ngIf="showPatientSelect">
                        <app-form-field
                            label=""
                            type="autocomplete"
                            [options]="selectOptionsPatients"
                            [fieldControl]="form.controls['selectedPatient'] | asFormControl">
                        </app-form-field>
                    </div>
                </section>

                <section class="filter-container">
                    <p class="subtitle">Ocultar</p>
                    <mat-checkbox formControlName="checkboxPayment">
                        Pago
                    </mat-checkbox>
                </section>

                <section class="filter-container">
                    <p class="subtitle">Agrupar por</p>
                    <mat-checkbox formControlName="checkboxDoctorSS">
                        Medico SS
                    </mat-checkbox>
                </section>
            </form>
        </div>
    </app-report-select>
</ng-container>
